module.exports = __webpack_public_path__ + "img/NokiaBellLogo1.62e88723.png";